module.exports = __webpack_public_path__ + "static/media/Library_5.d9ba5db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_5.png
// module id = 1292
// module chunks = 3